import { Controller } from "@hotwired/stimulus"

// Copying leaves the page exactly as it was, so the button is the only
// place the outcome can show. It reports for a moment, then goes back to
// offering the action — a button stuck on "Copied" cannot be used twice.
export default class extends Controller {
  static targets = ["idle", "done", "status"]
  static values = {
    text: String,
    copied: String,
    settle: { type: Number, default: 2000 }
  }

  disconnect() {
    clearTimeout(this.settling)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
    } catch {
      // No clipboard, no permission, or a context the browser refuses to
      // write from. The secret is on screen to be typed either way.
      return
    }

    this.#report()
  }

  #report() {
    this.idleTarget.classList.add("hidden")
    this.doneTarget.classList.remove("hidden")
    this.statusTarget.textContent = this.copiedValue

    clearTimeout(this.settling)
    this.settling = setTimeout(() => this.#offerAgain(), this.settleValue)
  }

  #offerAgain() {
    this.idleTarget.classList.remove("hidden")
    this.doneTarget.classList.add("hidden")
    this.statusTarget.textContent = ""
  }
}
